module.exports = __webpack_public_path__ + "static/media/cursor.bd43c414.svg";